import React from 'react';
import styles from './index.module.less';
import type { IFooterLinkItem } from '.';
import { FooterContext } from '../../common';
import { ReoIcon } from '@reolink-web/components.basic';
import classNames from 'classnames';

interface IFooterLinkItemProps {
    items: IFooterLinkItem[];
    title: string;
    isExpend: boolean;
    onExpendChange: (expand: boolean) => void;
}

const CompFooterLinkItem: React.FC<IFooterLinkItemProps> = (props) => {
    const { getTextByKey } = React.useContext(FooterContext);

    return (
        <li
            className={ classNames(styles['link-group'], {
                [styles['link-group-expend']]: props.isExpend,
            }) }
        >
            <h3
                className={ styles['link-group-title'] }
                // eslint-disable-next-line react/jsx-handler-names
                onClick={ () => {
                    props.onExpendChange(!props.isExpend);
                } }
            >
                <span className={ styles['link-group-title-text'] }>{props.title}</span>
                <ReoIcon
                    className={ styles['link-group-title-icon'] }
                    name={ 'icon-icon_plus' } />
            </h3>
            <ul className={ styles['link-group-list'] }>
                {props.items.map((linkItem) => {
                    return (
                        <li
                            key={ linkItem.key }
                            className={ styles['link-group-item'] }>
                            <a
                                href={ linkItem.link }
                                target={ linkItem.target }
                                rel={ linkItem.rel }
                                className={ classNames(
                                    styles['link-group-item-link'],
                                    linkItem.strong ? styles['link-group-item-link-strong'] : '',
                                ) }
                            >
                                <span>{linkItem.title || getTextByKey(linkItem.key)}</span>
                                {linkItem.strong ? (
                                    <ReoIcon
                                        className={ styles['link-group-item-icon'] }
                                        name={ 'icon-icon_arrow-right' }
                                    />
                                ) : null}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </li>
    );
};

export default CompFooterLinkItem;
